import { router } from "@/common/router";

/**
 * 페이지 이동 유틸리티 함수
 * 컴포넌트 외부에서도 사용 가능
 */
export const transitionTo = (path: string) => {
  router.navigate(path);
};
